import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logoNeuroResearch from "@/assets/logo-neuroresearch.webp";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          <div>
            <Link to="/de" className="inline-block mb-4">
              <img 
                src={logoNeuroResearch} 
                alt="NeuroResearch Foundation" 
                width={179}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Heute forschen, um morgen zu heilen. Engagiert dafür, Lösungen 
              für die anspruchsvollsten neurologischen Erkrankungen zu finden.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Forschung</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/de/forschungsprojekte" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Forschung und Projekte</Link></li>
              <li><Link to="/de/zusammenarbeit" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Zusammenarbeit</Link></li>
              <li><Link to="/de/klinische-studien" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Klinische Studien</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Teilnehmen</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link 
                  to="/de" 
                  onClick={() => {
                    setTimeout(() => {
                      const donationSection = document.getElementById('donation-section');
                      if (donationSection) {
                        donationSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="hover:text-primary transition-colors"
                >
                  Spenden
                </Link>
              </li>
              <li><Link to="/de/freiwilligenarbeit" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Freiwilligenarbeit</Link></li>
              <li><Link to="/de/veranstaltungen" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Veranstaltungen</Link></li>
              <li><Link to="/de/newsletter" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Bleiben Sie Informiert</h4>
            <p className="text-muted-foreground mb-4">
              Abonnieren Sie, um Updates über unsere Forschung zu erhalten
            </p>
            <div className="flex gap-2">
              <Button 
                variant="secondary"
                asChild
              >
                <Link to="/de/newsletter">Abonnieren</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © 2024 Green Life Bcn Foundation. Alle Rechte vorbehalten.
            </div>
            <div className="flex gap-6 text-muted-foreground">
              <Link to="/de/datenschutz" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Datenschutz</Link>
              <Link to="/de/nutzungsbedingungen" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Bedingungen</Link>
              <Link to="/de/kontakt" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Kontakt</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;